export const THIRD_APP_LIST = {
  telegram: '/common-static/cht-static/user-svc/img/logo-telegram.svg',
};

export enum BIND_APP_STATUS {
  UNBOUND = 0,
  BOUND = 1,
}
